function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 0.00024,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 12 1.000781 C 5.925 1.000781 1.000781 5.925 1.000781 12 C 1.000781 18.075 5.925 22.999219 12 22.999219 C 18.075 22.999219 22.999219 18.075 22.999219 12 C 22.992187 5.927344 18.072656 1.007812 12 1.000781 Z M 3.058594 13.000781 L 6.028125 13.000781 C 6.084375 15.43125 6.703125 17.817187 7.832812 19.971094 C 5.184375 18.58125 3.396094 15.970312 3.058594 13.000781 Z M 6.028125 10.999219 L 3.058594 10.999219 C 3.396094 8.029687 5.184375 5.41875 7.832812 4.028906 C 6.703125 6.182812 6.084375 8.56875 6.028125 10.999219 Z M 10.999219 20.664844 C 9.557812 19.729687 8.224219 16.872656 8.025 13.000781 L 10.999219 13.000781 Z M 10.999219 10.999219 L 8.025 10.999219 C 8.224219 7.127344 9.557812 4.270312 10.999219 3.335156 Z M 13.000781 20.664844 L 13.000781 13.000781 L 15.975 13.000781 C 15.775781 16.872656 14.442187 19.729687 13.000781 20.664844 Z M 13.000781 10.999219 L 13.000781 3.335156 C 14.442187 4.270312 15.775781 7.127344 15.975 10.999219 Z M 16.167187 19.971094 C 17.296875 17.817187 17.915625 15.43125 17.971875 13.000781 L 20.941406 13.000781 C 20.603906 15.970312 18.815625 18.58125 16.167187 19.971094 Z M 17.971875 10.999219 C 17.915625 8.56875 17.296875 6.182812 16.167187 4.028906 C 18.815625 5.41875 20.603906 8.029687 20.941406 10.999219 Z M 17.971875 10.999219 ",
    transform: "matrix(1.666667,0,0,1.666667,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.b64eb3135d4e5b19ba9bdb27823f9c16.svg";
export { ForwardRef as ReactComponent };